import { Link } from "react-router-dom";

const CTA_MAILTO =
  "mailto:info@pisttonsdrivingschool.co.nz?subject=Book%20a%20practical%20driving%20lesson";

export default function Landing() {
  return (
    <div className="space-y-10" data-testid="landing-page">
      <section className="hero-card space-y-4">
        <h1 className="text-4xl sm:text-5xl font-bold leading-tight" data-testid="landing-heading">
          GDI Academy
        </h1>
        <p className="text-base md:text-lg max-w-2xl hero-sub" data-testid="landing-subheading">
          New Zealand learner driver theory and practical learning support — study at your pace
          with clear explanations and verified official-source links where available.
        </p>
        <div className="flex flex-wrap gap-3 pt-2">
          <Link to="/register" className="btn-accent" data-testid="landing-register-cta">
            Create Learner Account
          </Link>
          <Link to="/login" className="btn-outline-light" data-testid="landing-login-cta">
            Log in
          </Link>
          <a href={CTA_MAILTO} className="btn-outline-light" data-testid="commercial-cta">
            Book a practical driving lesson
          </a>
        </div>
      </section>

      <section className="card space-y-3" data-testid="landing-theory">
        <h2 className="text-base md:text-lg font-semibold">Theory Test Preparation</h2>
        <p className="text-muted-foreground">
          Practise approved learner licence theory questions one at a time with immediate feedback,
          explanations, and official source links. Sit a 35-question practice mock test with a
          32/35 pass mark. Progress is saved to your learner account.
        </p>
        <p className="text-sm text-muted-foreground">
          GDI Academy does not reproduce every official NZTA test question and is not an official
          NZTA result.
        </p>
      </section>

      <section className="card space-y-3" data-testid="landing-pathways">
        <h2 className="text-base md:text-lg font-semibold">Learning pathways available now</h2>
        <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
          <li>
            <span className="font-medium text-foreground">Theory Test Preparation</span> — practice
            questions and practice mock tests
          </li>
          <li>
            <span className="font-medium text-foreground">Practical Driving Learning</span> —
            foundational on-road learning content within the learner programme
          </li>
          <li>
            <span className="font-medium text-foreground">Manual Driving</span> — optional separate
            programme for manual vehicle control
          </li>
        </ul>
      </section>

      <section className="card space-y-3" data-testid="landing-audience">
        <h2 className="text-base md:text-lg font-semibold">Who this is for</h2>
        <p className="text-muted-foreground">
          Learner drivers preparing for their New Zealand learner licence theory knowledge and
          their first practical driving lessons.
        </p>
      </section>

      <section className="card space-y-3" data-testid="landing-trust">
        <h2 className="text-base md:text-lg font-semibold">Independent educational platform</h2>
        <p className="text-muted-foreground" data-testid="landing-disclaimer">
          GDI Academy is an educational and training platform operated independently. It is not
          NZTA / Waka Kotahi and does not issue licences or official test results. Always refer to
          the official New Zealand Road Code for regulatory requirements.
        </p>
        <p className="text-muted-foreground" data-testid="landing-separate-product">
          GDI Academy is a separate product from the GDI operational app. It does not share logins,
          student records, lessons, invoices, or billing. Opening Academy from GDI does not pass
          identity, tokens, or progress.
        </p>
        <div className="flex flex-wrap gap-3 text-sm">
          <Link to="/privacy" className="underline" data-testid="landing-privacy-link">
            Privacy Notice
          </Link>
          <Link to="/terms" className="underline" data-testid="landing-terms-link">
            Terms
          </Link>
        </div>
      </section>
    </div>
  );
}
